import Link from "components/Link";

const LinkAdapter = ({ blok: { text, href } }) => <Link text={text} href={href} />;

export default LinkAdapter;
